import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'We bought our boat a few years ago from Freedom Boat Club Lake George. It was great knowing that the boat was well maintained. We have had no issues and Queen Boat continues to maintain our boat.',
    author: 'Nicole'
  }, {
    text: 'I purchased a boat from Freedom Boat Club and I also had Queen Boat Co sell one for me. I have had them service my boats as well. Fantastic company to do business with and the owner and employees are all top notch.',
    author: 'Don'
  }, {
    text: 'We are enjoying our tri-toon and 150 Mercury outboard you sold us. Runs and looks new. It was a pleasure working with you and your team on the delivery.',
    author: 'Doug'
  }];
  return <section className="py-20 px-6 md:px-12 bg-navy text-white" data-id="element-147">
      <div className="max-w-7xl mx-auto" data-id="element-148">
        <div className="text-center mb-16" data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-150">
            What Buyers Are Saying About Us
          </h2>
          <div className="w-24 h-1 bg-copper mx-auto rounded-full" data-id="element-151"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-152">
          {testimonials.map((testimonial, idx) => <div key={idx} className="bg-navy-800 rounded-2xl p-8 border border-navy-700 flex flex-col h-full" data-id="element-153">
              <div className="flex gap-1 mb-6" data-id="element-154">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-copper text-copper" data-id="element-155" />)}
              </div>
              <p className="text-navy-100 text-lg italic mb-8 flex-grow leading-relaxed" data-id="element-156">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-157">
                <div className="w-12 h-12 bg-copper rounded-full flex items-center justify-center text-xl font-heading font-bold text-white" data-id="element-158">
                  {testimonial.author.charAt(0)}
                </div>
                <div data-id="element-159">
                  <p className="font-heading font-semibold text-white" data-id="element-160">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-navy-300" data-id="element-161">Boat Buyer</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}